{
  "familyId": "MET-INH-BLOK",
  "questions": [
    {
      "id": "MET-INH-BLOK-001",
      "familyId": "MET-INH-BLOK",
      "module": "Metriek",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inh_blok",
      "questionType": "multiple_choice",
      "question": "Een doos is 5 cm lang, 4 cm breed en 3 cm hoog. Wat is de inhoud?",
      "context": null,
      "options": ["60 cm³", "120 cm³", "20 cm³", "15 cm³"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "box3d",
          "data": { "length": 5, "depth": 4, "height": 3, "showGrid": false, "unit": "cm", "label": "Doos" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud balk",
            "content": "Inhoud = lengte × breedte × hoogte. Dus: 5 × 4 × 3 = 60 cm³. Let op: het antwoord is in cm³ (kubieke centimeter)!"
          }
        }
      ],
      "conceptId": "volume_cuboid_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Inhoud van een balk = lengte × breedte × hoogte = 5 × 4 × 3 = 60 cm³. Stap voor stap: 5 × 4 = 20, dan 20 × 3 = 60.",
        "solutionSteps": [
          "Formule: inhoud = lengte × breedte × hoogte",
          "Vul in: 5 × 4 × 3",
          "Bereken: 5 × 4 = 20, dan 20 × 3 = 60 cm³"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 × 4 × 3 = 60 cm³.",
          "1": "Je vermenigvuldigde een keer extra. Inhoud = lengte × breedte × hoogte = 5 × 4 × 3 = 60, niet 120.",
          "2": "Je rekende 5 × 4 = 20. Dat is de oppervlakte van het bovenvlak — de hoogte ontbreekt: × 3 = 60 cm³.",
          "3": "Je vergat de breedte (4). Alle drie de afmetingen meedoen: 5 × 4 × 3 = 60 cm³."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-extra-factor", "label": "Vermenigvuldigde een keer te veel", "optionIndex": 1 },
          { "id": "met.inhoud-oppervlakte-ipv-inhoud", "label": "Berekende oppervlakte i.p.v. inhoud", "optionIndex": 2 },
          { "id": "met.inhoud-dimensie-vergeten", "label": "Vergat een afmeting", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-BLOK-002",
      "familyId": "MET-INH-BLOK",
      "module": "Metriek",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inh_blok",
      "questionType": "multiple_choice",
      "question": "Een balk heeft een inhoud van 24 cm³. De lengte is 6 cm en de breedte is 2 cm. Wat is de hoogte?",
      "context": null,
      "options": ["1 cm", "4 cm", "2 cm", "16 cm"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "box3d",
          "data": { "length": 6, "depth": 2, "height": null, "showGrid": false, "unit": "cm", "label": "? hoogte" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogte berekenen",
            "content": "Inhoud = lengte × breedte × hoogte. Je weet: 24 = 6 × 2 × hoogte = 12 × hoogte. Dus: hoogte = 24 ÷ 12 = 2 cm."
          }
        }
      ],
      "conceptId": "volume_cuboid_reverse",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Formule omdraaien: hoogte = inhoud ÷ (lengte × breedte) = 24 ÷ (6 × 2) = 24 ÷ 12 = 2 cm. Check: 6 × 2 × 2 = 24 ✓.",
        "solutionSteps": [
          "Formule: 24 = 6 × 2 × hoogte",
          "Bereken bekend deel: 6 × 2 = 12",
          "Hoogte = 24 ÷ 12 = 2 cm",
          "Check: 6 × 2 × 2 = 24 ✓"
        ],
        "distractorExplanations": {
          "0": "Je deed 24 ÷ 24. Maar je deelt door lengte × breedte (= 12), niet door 24. Hoogte = 24 ÷ 12 = 2 cm.",
          "1": "Je deed 24 ÷ 6 = 4. Maar je moet door BEIDE bekende maten delen: 24 ÷ (6 × 2) = 2 cm.",
          "2": "Goed! Hoogte = 24 ÷ 12 = 2 cm.",
          "3": "Je trok af: 24 − 6 − 2 = 16. Maar bij inhoud deel je, niet aftrekken."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.inhoud-door-inhoud-gedeeld", "label": "Door inhoud zelf gedeeld", "optionIndex": 0 },
          { "id": "met.inhoud-door-een-dim-gedeeld", "label": "Door één afmeting gedeeld i.p.v. beide", "optionIndex": 1 },
          { "id": "met.inhoud-aftrekken-ipv-delen", "label": "Aftrekken i.p.v. delen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-BLOK-003",
      "familyId": "MET-INH-BLOK",
      "module": "Metriek",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inh_blok",
      "questionType": "multiple_choice",
      "question": "Een aquarium is 40 cm lang, 25 cm breed en 30 cm hoog. Wat is de inhoud in cm³?",
      "context": null,
      "options": ["120.000 cm³", "30.000 cm³", "1.000 cm³", "3.000 cm³"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "box3d",
          "data": { "length": 40, "depth": 25, "height": 30, "showGrid": false, "unit": "cm", "label": "Aquarium" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud aquarium",
            "content": "Inhoud = lengte × breedte × hoogte = 40 × 25 × 30. Stap voor stap: 40 × 25 = 1.000, dan 1.000 × 30 = 30.000 cm³."
          }
        }
      ],
      "conceptId": "volume_cuboid_context",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Inhoud = 40 × 25 × 30. Stap 1: 40 × 25 = 1.000. Stap 2: 1.000 × 30 = 30.000 cm³.",
        "solutionSteps": [
          "Formule: inhoud = lengte × breedte × hoogte",
          "Stap 1: 40 × 25 = 1.000",
          "Stap 2: 1.000 × 30 = 30.000 cm³"
        ],
        "distractorExplanations": {
          "0": "Je vermenigvuldigde te veel. Reken na: 40 × 25 × 30 = 30.000, niet 120.000.",
          "1": "Goed! 40 × 25 × 30 = 30.000 cm³.",
          "2": "Je stopte bij 40 × 25 = 1.000. Vergeet de hoogte niet: × 30 = 30.000 cm³.",
          "3": "Je gebruikte hoogte 3 i.p.v. 30. Lees de maten goed: 40 × 25 × 30 = 30.000 cm³."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-extra-factor", "label": "Te veel vermenigvuldigd", "optionIndex": 0 },
          { "id": "met.inhoud-oppervlakte-ipv-inhoud", "label": "Stopte bij oppervlakte", "optionIndex": 2 },
          { "id": "met.inhoud-getal-verkeerd-gelezen", "label": "Getal verkeerd gelezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-BLOK-004",
      "familyId": "MET-INH-BLOK",
      "module": "Metriek",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inh_blok",
      "questionType": "multiple_choice",
      "question": "Een kubus heeft ribben van 4 cm. Wat is de inhoud?",
      "context": null,
      "options": ["96 cm³", "16 cm³", "12 cm³", "64 cm³"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "box3d",
          "data": { "length": 4, "depth": 4, "height": 4, "showGrid": false, "unit": "cm", "label": "Kubus" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud kubus",
            "content": "Een kubus heeft gelijke ribben. Inhoud = ribbe × ribbe × ribbe = 4 × 4 × 4 = 64 cm³. Dit is hetzelfde als 4³."
          }
        }
      ],
      "conceptId": "volume_cube",
      "variantIndex": 4,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een kubus heeft gelijke ribben. Inhoud = ribbe³ = 4 × 4 × 4 = 64 cm³.",
        "solutionSteps": [
          "Een kubus: alle ribben gelijk (4 cm)",
          "Inhoud = 4 × 4 × 4",
          "4 × 4 = 16, dan 16 × 4 = 64 cm³"
        ],
        "distractorExplanations": {
          "0": "Je rekende 4 × 4 × 6. De 6 is het aantal vlakken, niet een afmeting. Inhoud = 4 × 4 × 4 = 64 cm³.",
          "1": "4 × 4 = 16 is de oppervlakte van één vlak. Voor inhoud × 4: 16 × 4 = 64 cm³.",
          "2": "Je telde de ribben op: 4 + 4 + 4 = 12. Voor inhoud moet je vermenigvuldigen: 4 × 4 × 4 = 64.",
          "3": "Goed! 4 × 4 × 4 = 64 cm³."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-vlakken-als-afmeting", "label": "Aantal vlakken als afmeting gebruikt", "optionIndex": 0 },
          { "id": "met.inhoud-oppervlakte-ipv-inhoud", "label": "Oppervlakte i.p.v. inhoud", "optionIndex": 1 },
          { "id": "met.inhoud-optellen-ipv-vermenigvuldigen", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-INH-BLOK-005",
      "familyId": "MET-INH-BLOK",
      "module": "Metriek",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "inhoud",
      "subSkill": "inh_blok",
      "questionType": "multiple_choice",
      "question": "Welke balk heeft de grootste inhoud?",
      "context": null,
      "options": ["8 × 6 × 4 cm", "10 × 5 × 4 cm", "12 × 3 × 5 cm", "9 × 5 × 4 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud vergelijken",
            "content": "Bereken elke inhoud: 8×6×4=192, 10×5×4=200, 12×3×5=180, 9×5×4=180. De grootste is 200 cm³."
          }
        }
      ],
      "conceptId": "volume_cuboid_compare",
      "variantIndex": 5,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bereken elke inhoud: 8×6×4=192, 10×5×4=200, 12×3×5=180, 9×5×4=180. De grootste is 200 cm³.",
        "solutionSteps": [
          "A: 8 × 6 × 4 = 192 cm³",
          "B: 10 × 5 × 4 = 200 cm³",
          "C: 12 × 3 × 5 = 180 cm³",
          "D: 9 × 5 × 4 = 180 cm³",
          "Grootste: B = 200 cm³"
        ],
        "distractorExplanations": {
          "0": "8 × 6 × 4 = 192. Maar 10 × 5 × 4 = 200, dat is meer.",
          "1": "Goed! 10 × 5 × 4 = 200 cm³ is de grootste.",
          "2": "Je koos C omdat 12 het grootst is. Maar 12 × 3 × 5 = 180 < 200. Het gaat om het product van alle drie.",
          "3": "9 × 5 × 4 = 180. Maar 10 × 5 × 4 = 200, dat is meer."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.inhoud-grootste-afmeting-drogreden", "label": "Kiest op basis van één grootste afmeting", "optionIndex": 2 },
          { "id": "met.inhoud-rekenfout", "label": "Rekenfout bij vergelijken", "optionIndex": 0 },
          { "id": "met.inhoud-rekenfout", "label": "Rekenfout bij vergelijken", "optionIndex": 3 }
        ]
      }
    }
  ]
}